// extracted by mini-css-extract-plugin
export default {"container":"ChangePassword_container__xfyXv","focus-visible":"ChangePassword_focus-visible__q55Cl"};